import { Routes, Route } from 'react-router-dom';
import SEOHead from './components/common/SEOHead';
import { SITE_CONFIG } from './config/seo';

import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import PostPage from './pages/PostPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPosts from './pages/admin/AdminPosts';
import AdminCreatePost from './pages/admin/AdminCreatePost';
import AdminEditPost from './pages/admin/AdminEditPost';
import AdminSettings from './pages/admin/AdminSettings';
import AdminComments from './pages/admin/AdminComments';
import AdminGallery from './pages/admin/AdminGallery';
import NotFoundPage from './pages/NotFoundPage';
import LoginForm from './components/auth/LoginForm';
import { useAuth } from './contexts/AuthContext';

function App() {
  const { login } = useAuth();

  return (
    <>
      <SEOHead
        title={SITE_CONFIG.tagline}
        description={SITE_CONFIG.defaultDescription}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: SITE_CONFIG.name,
          url: SITE_CONFIG.domain,
          logo: SITE_CONFIG.defaultImage,
          sameAs: [SITE_CONFIG.youtube],
        }}
      />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<PostPage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>

        {/* Auth Routes */}
        <Route path="/login" element={<LoginForm onLogin={login} />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="posts" element={<AdminPosts />} />
          <Route path="posts/new" element={<AdminCreatePost />} />
          <Route path="posts/edit/:id" element={<AdminEditPost />} />
          <Route path="comments" element={<AdminComments />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="gallery" element={<AdminGallery />} />
        </Route>

        {/* 404 Route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
